export default "__VITE_ASSET__nApR9GC2__"